export default __webpack_public_path__ + "static/media/1996.dbd40da9.png";